import { Card } from "@/components/ui/card";
import { MarketPenetrationSection } from "./market-sections/MarketPenetrationSection";
import { ValidationMetricsSection } from "./market-sections/ValidationMetricsSection";

interface AdditionalMarketParametersProps {
  marketPenetration: string;
  setMarketPenetration: (value: string) => void;
  customerAcquisitionRate: string;
  setCustomerAcquisitionRate: (value: string) => void;
  penetrationStrategies: string[];
  setPenetrationStrategies: (value: string[]) => void;
  marketValidation: string;
  setMarketValidation: (value: string) => void;
  benchmarkRequested: boolean;
  setBenchmarkRequested: (value: boolean) => void;
  churnRate: string;
  setChurnRate: (value: string) => void;
  customerLTV: string;
  setCustomerLTV: (value: string) => void;
  customerCAC: string;
  setCustomerCAC: (value: string) => void;
}

export const AdditionalMarketParameters = ({
  marketPenetration,
  setMarketPenetration,
  customerAcquisitionRate,
  setCustomerAcquisitionRate,
  penetrationStrategies,
  setPenetrationStrategies,
  marketValidation,
  setMarketValidation,
  benchmarkRequested,
  setBenchmarkRequested,
  churnRate,
  setChurnRate,
  customerLTV,
  setCustomerLTV,
  customerCAC,
  setCustomerCAC,
}: AdditionalMarketParametersProps) => {
  return (
    <div className="space-y-6">
      <Card className="p-4">
        <h3 className="text-lg font-semibold mb-4">Market Penetration</h3>
        <MarketPenetrationSection
          marketPenetration={marketPenetration}
          setMarketPenetration={setMarketPenetration}
          customerAcquisitionRate={customerAcquisitionRate}
          setCustomerAcquisitionRate={setCustomerAcquisitionRate}
          penetrationStrategies={penetrationStrategies}
          setPenetrationStrategies={setPenetrationStrategies}
        />
      </Card>

      <Card className="p-4">
        <h3 className="text-lg font-semibold mb-4">Validation & Advanced Metrics</h3>
        <ValidationMetricsSection
          marketValidation={marketValidation}
          setMarketValidation={setMarketValidation}
          benchmarkRequested={benchmarkRequested}
          setBenchmarkRequested={setBenchmarkRequested}
          churnRate={churnRate}
          setChurnRate={setChurnRate}
          customerLTV={customerLTV}
          setCustomerLTV={setCustomerLTV}
          customerCAC={customerCAC}
          setCustomerCAC={setCustomerCAC}
        />
      </Card>
    </div>
  );
};